function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("date-fns")) : "function" == typeof define && define.amd ? define(["date-fns"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["date-queries"] = e(require("date-fns")) : t["date-queries"] = e(t["date-fns"]);
}(window, function (t) {
  return function (t) {
    var e = {};

    function r(s) {
      if (e[s]) return e[s].exports;
      var n = e[s] = {
        i: s,
        l: !1,
        exports: {}
      };
      return t[s].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, s) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: s
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var s = Object.create(null);
      if (r.r(s), Object.defineProperty(s, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var n in t) {
        r.d(s, n, function (e) {
          return t[e];
        }.bind(null, n));
      }
      return s;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 1);
  }([function (e, r) {
    e.exports = t;
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    var s,
        n = r(0);
    e.default = function (t, e, r) {
      return new s(t, e, r).value();
    }, s =
    /*#__PURE__*/
    function () {
      function s(t, e, r) {
        _classCallCheck(this, s);

        this.dtstart = t, this.dtstartStartOfDay = Object(n.startOfDay)(t), this.dtend = e, this.dtendStartOfDay = Object(n.endOfDay)(e), this.queries = r;
      }

      _createClass(s, [{
        key: "value",
        value: function value() {
          var t, e, r, s, n;

          for (t = 0, e = (s = this.queries).length; t < e; t++) {
            if (r = s[t], n = this.processQuery(r)) return "function" == typeof r ? n : r;
          }
        }
      }, {
        key: "processQuery",
        value: function processQuery(t) {
          switch (t) {
            case "now":
            case "today":
              return this.todayQuery();

            case "tomorrow":
              return this.tomorrowQuery();

            case "yesterday":
              return this.yesterdayQuery();

            case "this-week":
              return this.thisWeekQuery();

            case "next-week":
              return this.nextWeekQuery();

            case "past-week":
              return this.pastWeekQuery();

            case "this-month":
              return this.thisMonthQuery();

            case "next-month":
              return this.nextMonthQuery();

            case "past-month":
              return this.pastMonthQuery();

            case "this-year":
              return this.thisYearQuery();

            case "next-year":
              return this.nextYearQuery();

            case "past-year":
              return this.pastYearQuery();

            case "next":
              return this.nextQuery();

            case "past":
              return this.pastQuery();

            case "nearest-weekend":
              return this.nearestWeekendQuery();

            case "weekend":
              return this.weekendQuery();

            case "rest-of-this-week":
              return this.restOfThisWeekQuery();

            default:
              if ("function" == typeof t) return t(this.dtstart, this.dtend);
          }
        }
      }, {
        key: "todayQuery",
        value: function todayQuery() {
          var t;
          return this.dtend ? (t = new Date(), Object(n.isWithinRange)(t, this.dtstartStartOfDay, this.dtendStartOfDay)) : Object(n.isToday)(this.dtstart);
        }
      }, {
        key: "tomorrowQuery",
        value: function tomorrowQuery() {
          var t;
          return this.dtend ? (t = Object(n.addDays)(new Date(), 1), Object(n.isWithinRange)(t, this.dtstartStartOfDay, this.dtendStartOfDay)) : Object(n.isTomorrow)(this.dtstart);
        }
      }, {
        key: "yesterdayQuery",
        value: function yesterdayQuery() {
          var t;
          return this.dtend ? (t = Object(n.subDays)(new Date(), 1), Object(n.isWithinRange)(t, this.dtstartStartOfDay, this.dtendStartOfDay)) : Object(n.isYesterday)(this.dtstart);
        }
      }, {
        key: "thisWeekQuery",
        value: function thisWeekQuery() {
          var t;
          return this.dtend ? (t = new Date(), Object(n.areRangesOverlapping)(Object(n.startOfWeek)(t), Object(n.endOfWeek)(t), this.dtstart, this.dtend)) : Object(n.isThisWeek)(this.dtstart);
        }
      }, {
        key: "nextWeekQuery",
        value: function nextWeekQuery() {
          var t, e, r;
          return e = new Date(), r = Object(n.addDays)(Object(n.endOfWeek)(e), 1), t = Object(n.endOfWeek)(r), this.dtend ? Object(n.areRangesOverlapping)(r, t, this.dtstart, this.dtend) : Object(n.isWithinRange)(this.dtstart, r, t);
        }
      }, {
        key: "pastWeekQuery",
        value: function pastWeekQuery() {
          var t, e, r;
          return e = new Date(), t = Object(n.subDays)(Object(n.startOfWeek)(e), 1), r = Object(n.startOfWeek)(t), this.dtend ? Object(n.areRangesOverlapping)(r, t, this.dtstart, this.dtend) : Object(n.isWithinRange)(this.dtstart, r, t);
        }
      }, {
        key: "thisMonthQuery",
        value: function thisMonthQuery() {
          var t;
          return this.dtend ? (t = new Date(), Object(n.areRangesOverlapping)(Object(n.startOfMonth)(t), Object(n.endOfMonth)(t), this.dtstart, this.dtend)) : Object(n.isThisMonth)(this.dtstart);
        }
      }, {
        key: "nextMonthQuery",
        value: function nextMonthQuery() {
          var t, e, r;
          return e = new Date(), r = Object(n.addDays)(Object(n.endOfMonth)(e), 1), t = Object(n.endOfMonth)(r), this.dtend ? Object(n.areRangesOverlapping)(r, t, this.dtstart, this.dtend) : Object(n.isWithinRange)(this.dtstart, r, t);
        }
      }, {
        key: "pastMonthQuery",
        value: function pastMonthQuery() {
          var t, e, r;
          return e = new Date(), t = Object(n.subDays)(Object(n.startOfMonth)(e), 1), r = Object(n.startOfMonth)(t), this.dtend ? Object(n.areRangesOverlapping)(r, t, this.dtstart, this.dtend) : Object(n.isWithinRange)(this.dtstart, r, t);
        }
      }, {
        key: "thisYearQuery",
        value: function thisYearQuery() {
          var t;
          return this.dtend ? (t = new Date(), Object(n.areRangesOverlapping)(Object(n.startOfYear)(t), Object(n.endOfYear)(t), this.dtstart, this.dtend)) : Object(n.isThisYear)(this.dtstart);
        }
      }, {
        key: "nextYearQuery",
        value: function nextYearQuery() {
          var t, e, r;
          return e = new Date(), r = Object(n.addDays)(Object(n.endOfYear)(e), 1), t = Object(n.endOfYear)(r), this.dtend ? Object(n.areRangesOverlapping)(r, t, this.dtstart, this.dtend) : Object(n.isWithinRange)(this.dtstart, r, t);
        }
      }, {
        key: "pastYearQuery",
        value: function pastYearQuery() {
          var t, e, r;
          return e = new Date(), t = Object(n.subDays)(Object(n.startOfYear)(e), 1), r = Object(n.startOfYear)(t), this.dtend ? Object(n.areRangesOverlapping)(r, t, this.dtstart, this.dtend) : Object(n.isWithinRange)(this.dtstart, r, t);
        }
      }, {
        key: "nextQuery",
        value: function nextQuery() {
          return Object(n.isFuture)(Object(n.startOfDay)(this.dtstart));
        }
      }, {
        key: "pastQuery",
        value: function pastQuery() {
          return this.dtend ? Object(n.isPast)(Object(n.endOfDay)(this.dtend)) : Object(n.isPast)(Object(n.endOfDay)(this.dtstart));
        }
      }, {
        key: "nearestWeekendQuery",
        value: function nearestWeekendQuery() {
          var t, e, r;
          return e = new Date(), t = Object(n.endOfDay)(Object(n.lastDayOfWeek)(e, {
            weekStartsOn: 1
          })), r = Object(n.startOfDay)(Object(n.subDays)(t, 1)), this.dtend ? Object(n.areRangesOverlapping)(r, t, this.dtstart, this.dtend) : Object(n.isWithinRange)(this.dtstart, r, t);
        }
      }, {
        key: "weekendQuery",
        value: function weekendQuery() {
          var t, e, r, s;
          if (!this.dtend) return Object(n.isWeekend)(this.dtstart);

          for (e = 0, r = (s = Object(n.eachDay)(this.dtstart, this.dtend)).length; e < r; e++) {
            if (t = s[e], Object(n.isWeekend)(t)) return !0;
          }
        }
      }, {
        key: "restOfThisWeekQuery",
        value: function restOfThisWeekQuery() {
          var t;
          return t = new Date(), this.dtend ? Object(n.areRangesOverlapping)(Object(n.startOfDay)(t), Object(n.endOfDay)(Object(n.endOfWeek)(t)), this.dtstart, this.dtend) : Object(n.isAfter)(this.dtstart, Object(n.startOfDay)(t)) && Object(n.isThisWeek)(this.dtstart);
        }
      }]);

      return s;
    }();
  }]);
});